import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6" id="categories">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按分类快速找到你喜欢的作品类型，每种分类都为你精选了最优质的内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== 'all').map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-all duration-300 mb-3">
                <i className={`${category.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm md:text-base font-heading whitespace-nowrap">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 text-center line-clamp-2">
                {category.description}
              </p>
              <span className="mt-2 text-[10px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                {category.count}部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}